"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoPuntPoiProvider = void 0;
const GeocodingProvider_1 = require("./GeocodingProvider");
class GeoPuntPoiProvider extends GeocodingProvider_1.default {
    constructor(settings) {
        super("geopunt");
        this.apiRoot = "https://poi.api.geopunt.be/v1/core";
        this.settings = settings !== null && settings !== void 0 ? settings : {
            maxCount: 2
        };
        console.log(this.settings);
    }
    forward(query, callback) {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", `${this, this.apiRoot}?Theme=Onderwijs&Keyword=${query.string}`);
        xhr.onload = () => {
            if (xhr.status === 200) {
                const response = JSON.parse(xhr.responseText);
                if (response.pois) {
                    const results = [];
                    response.pois.forEach(l => {
                        if (results.length >= this.settings.maxCount)
                            return;
                        const location = l.location.points[0].Point.coordinates;
                        const lon = location[0];
                        const lat = location[1];
                        // check bounds, if outside, don't return as result.
                        if (typeof this.settings.bounds !== "undefined") {
                            if (this.settings.bounds[0] > lon)
                                return;
                            if (this.settings.bounds[2] < lon)
                                return;
                            if (this.settings.bounds[1] > lat)
                                return;
                            if (this.settings.bounds[3] < lat)
                                return;
                        }
                        const description = `${l.labels[0].value}, ${l.location.address.street} ${l.location.address.streetnumber} ${l.location.address.postalcode} ${l.location.address.municipality}`;
                        results.push({
                            description: description,
                            location: {
                                lng: lon,
                                lat: lat
                            },
                            type: "school",
                            score: 80,
                            provider: this.name,
                            raw: l
                        });
                    });
                    callback(results);
                }
            }
            else {
                console.log("geocode failed: " + xhr.status);
            }
        };
        xhr.send();
    }
    reverse(l, callback) {
        return callback([]);
    }
}
exports.GeoPuntPoiProvider = GeoPuntPoiProvider;
